import { createI18n, useI18n as useVueI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'
import zhTW from './zh-TW'

const messages = { en, zh, 'zh-TW': zhTW }

export const langNames = {
  en: 'English',
  zh: '简体中文',
  'zh-TW': '繁體中文'
}
export const langList = ['en', 'zh', 'zh-TW']

// 获取存储的语言或浏览器语言
function getDefaultLang() {
  const stored = localStorage.getItem('lang')
  if (stored && langList.includes(stored)) {
    return stored
  }
  const browserLang = navigator.language.toLowerCase()
  if (browserLang.startsWith('zh-tw') || browserLang.startsWith('zh-hk')) {
    return 'zh-TW'
  }
  if (browserLang.startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLang(),
  fallbackLocale: 'en',
  messages,
  // 在生产环境下禁用警告
  silentTranslationWarn: import.meta.env.PROD,
  silentFallbackWarn: import.meta.env.PROD,
  // 修复链接格式问题
  missingWarn: false,
  fallbackWarn: false,
  // 使用运行时编译器
  globalInjection: true,
  // 允许HTML内容
  allowComposition: true
})

export default i18n

// 设置语言
export function setLang(lang) {
  if (langList.includes(lang)) {
    i18n.global.locale.value = lang
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
  }
}

// 切换语言（循环切换）
export function toggleLang() {
  const currentIndex = langList.indexOf(i18n.global.locale.value)
  const nextIndex = (currentIndex + 1) % langList.length
  setLang(langList[nextIndex])
}

// 获取语言名称
export function getLangName(lang) {
  return langNames[lang] || lang
}

// 导出 composable 函数，用于在组件中使用
// 这个函数包装了 vue-i18n 的 useI18n，并添加了额外的功能
export function useI18n() {
  const { locale, t } = useVueI18n()
  
  return {
    lang: locale,
    t,
    setLang,
    langList,
    getLangName
  }
}
